package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class FixedProductsHeadersEnum(
    val isNumeric:Boolean,
    val key:String
):TitleEnum {
    NUMBER(
        isNumeric = false,
        key = "code",
    ),
    ARTICLE(
        isNumeric = false,
        key = "",
    ),
    QUANTITY(
        isNumeric = true,
        key = "amount",
    ),
    PRICE(
        isNumeric = true,
        key = "price",
    );

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
               NUMBER -> strings.number
               ARTICLE -> strings.article
               QUANTITY -> strings.quantity
               PRICE -> strings.price
            }
        }
}